export default {
  "airdropConfig.title": "红包雨配置",
  "airdropConfig.column.no": "#序号",
  "airdropConfig.column.taskId": "任务ID",
  "airdropConfig.column.title": "标题",
  "airdropConfig.column.amount": "金额范围",
  "airdropConfig.column.scopeDesc": "用户范围",
  "airdropConfig.column.enable": "状态",
  "airdropConfig.column.typeDesc": "类型",
  "airdropConfig.column.statusDesc": "重复",
  "airdropConfig.column.createTime": "创建时间",
  "airdropConfig.column.pushTime": "推送时间",
  "airdropConfig.column.action": "操作",
  "airdropConfig.action.delete": "删除",
  "airdropConfig.action.start": "启动任务",
  "airdropConfig.action.stop": "停止任务",
  "airdropConfig.action.details": "详情",
  "airdropConfig.action.edit": "编辑",
  "airdropConfig.form.title": "标题",
  "airdropConfig.form.type": "类型",
  "airdropConfig.form.type.once": "一次性任务",
  "airdropConfig.form.type.fixed": "固定任务",
  "airdropConfig.form.scopeType": "范围",
  "airdropConfig.form.scopeType.recharge": "最近几天充值",
  "airdropConfig.form.scopeType.designated": "指定用户",
  "airdropConfig.form.pushTime": "推送时间",
  "airdropConfig.form.pushTime.start": "开始时间",
  "airdropConfig.form.pushTime.end": "结束时间",
  "airdropConfig.form.usernoList": "会员ID",
  "airdropConfig.form.usernoList.placeholder": "请输入会员ID，逗号分隔",
  "airdropConfig.form.depositNearDays": "充值近几天",
  "airdropConfig.form.depositNearDays.placeholder": "输入天数",
  "airdropConfig.form.day": "天",
  "airdropConfig.form.probabilityList": "金额配置",
  "airdropConfig.form.probabilityList.required": "请至少添加一个金额配置",
  "airdropConfig.form.amount": "金额",
  "airdropConfig.form.amount.placeholder": "输入金额",
  "airdropConfig.form.probability": "概率",
  "airdropConfig.form.probability.placeholder": "输入概率",
  "airdropConfig.form.probabilityTotal.error": "所有概率之和必须等于100%",
  "airdropConfig.confirm.delete.title": "删除红包雨任务",
  "airdropConfig.confirm.delete.content": "确定要删除此红包雨任务吗？",
  "airdropConfig.confirm.start.title": "启动任务",
  "airdropConfig.confirm.start.content": "确定要启动此任务吗？",
  "airdropConfig.confirm.stop.title": "停止任务",
  "airdropConfig.confirm.stop.content": "确定要停止此任务吗？",
  "airdropConfig.confirm.ok": "确认",
  "airdropConfig.confirm.cancel": "取消",
  "airdropConfig.add": "新增任务",
  "airdropConfig.edit": "编辑",
  "airdropConfig.status.start": "启动",
  "airdropConfig.status.stop": "停止",
  "airdropConfig.modal.add.title": "新增红包雨任务",
  "airdropConfig.modal.details.title": "红包雨任务详情",
  "airdropConfig.modal.edit.title": "编辑红包雨任务",
};

